/**
 * Standard light neutrals for surfaces, hairlines, and wells.
 * Use via `import { uiNeutrals } from "…/constants/uiNeutrals"` or
 * `theme.palette.neutral.*` (see theme.js).
 */
export const uiNeutrals = {
  /** Search bars, soft gray buttons, muted control fills */
  surface: "#f3f2ed",
  surfaceHover: "#e9e8e2",
  surfaceBorder: "#e0dfd8",
  /** List row separators */
  rowDivider: "#eceef2",
  /** Image placeholders, inactive wells */
  well: "#f1f3f6",
  wellBorder: "#e6e8ec",
  /** “Following” pill (muted control, IG-style) */
  followingControl: "#f3f2ed",
  followingControlHover: "#e9e8e2",
  /** Frosted floating toggles (grid/list, calendar/restaurants, header pills) */
  frostedToggleBorder: "1px solid rgba(0, 0, 0, 0.06)",
  /** High-white frosted fill — translucent enough for backdrop-filter to read on #fdfcfb */
  frostedFill: "rgba(255, 255, 255, 0.58)",
  frostedFillHover: "rgba(255, 255, 255, 0.78)",
  /** Fixed bottom layout toggles (Explore grid/list, Following calendar/restaurants) */
  bottomToggleFrosted: "rgba(255, 255, 255, 0.55)",
  /** Scroll-up: milkier glass vs base — still white/translucent, not gray slab */
  bottomToggleFrostedElevated: "rgba(255, 255, 255, 0.82)",
  /** Slightly stronger edge when scroll-up state is active */
  bottomToggleBorderElevated: "1px solid rgba(0, 0, 0, 0.075)",
};

export default uiNeutrals;
